{
  "more": "Mai multe articole"
}
